<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    AppTitle.u-mb-xs(:title="$t('solutions.title')" tag="h2")
    .grid.is-widescreen-6.is-desktop-8.is-tablet-10
      .column
        p.u-mb-sm.u-text-lg {{$t('solutions.desc')}}
    .grid.is-labs.is-widescreen-3.is-tablet-6
      .column.u-mb-xm(v-for="item in $t('solutions.items')")
        h4: AppLink(:to="item.url" :title="item.title") {{item.title}}
        p {{item.desc}}
    .u-mb-md
      AppLink.button-link.is-medium(:to="$t('solutions.url')" :title="$t('viewMore')") {{$t('viewMore')}}

  .u-divider
  section.u-mt-md
    AppTitle.u-mb-xs(:title="$t('services.title')" tag="h2")
    .grid.is-widescreen-6.is-desktop-8.is-tablet-10
      .column
        p.u-mb-sm.u-text-lg {{$t('services.desc')}}
    .grid.is-labs.is-widescreen-3.is-tablet-6
      .column.u-mb-xm(v-for="item in $t('services.items')")
        h4: AppLink(:to="item.url" :title="item.title") {{item.title}}
        p {{item.desc}}
    .u-mb-md
      AppLink.button-link.is-medium(:to="$t('services.url')" :title="$t('viewMore')") {{$t('viewMore')}}

  .u-divider
  section.u-mt-md
    AppTitle.u-mb-xs(:title="$t('industries.title')" tag="h2")
    .grid.is-widescreen-6.is-desktop-8.is-tablet-10
      .column
        p.u-mb-sm.u-text-lg {{$t('industries.desc')}}
    .grid.is-labs.is-widescreen-3.is-tablet-6
      .column.u-mb-xm(v-for="item in $t('industries.items')")
        h4: AppLink(:to="item.url" :title="item.title") {{item.title}}
        p {{item.desc}}
    .u-mb-md
      AppLink.button-link.is-medium(:to="$t('industries.url')" :title="$t('viewMore')") {{$t('viewMore')}}


  section.u-mt-sm.u-mb-md
    .grid.is-ultrawide-8.is-desktop-9.is-tablet-10
      .column
        AppTitle.u-mb-sm(tag="h3" :title="$t('ctaText')")

    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,
  meta: {
    logoText: 'capabilities'
  },
  head: generateSeoMeta(
    {
      title: 'pageTitle',
      description: 'pageDesc'
    },
    { i18n: true }
  )
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat capabilities",
    "pageDesc":"In Baianat, we innovate to fulfill human needs in all our areas of expertise through services industries, solutions and platforms.",
    "mantra":"Innovation tailored |for human needs.",
    "solutions":{
      "title":"Solutions",
      "desc":"Creating industry based solutions to support your business infrastructure with technology.",
      "url":"/solutions",
      "items":{
        "1":{
          "title":"Brand",
          "desc":"Have an identity that expresses your essene both visually and verbally. ",
          "url":"/solutions/brand"
        },
        "2":{
          "title":"Web apps",
          "desc":"Building websites around your business functions and customers needs.",
          "url":"/solutions/web-apps"
        },
        "3":{
          "title":"Mobile apps",
          "desc":"Reach your clients anywhere through custom iOS and Android Apps.",
          "url":"/solutions/mobile-apps"
        },
        "4":{
          "title":"Store",
          "desc":"Create your online presence,increase your sales and gain more clients.",
          "url":"/solutions/store"
        }
      }
    },
    "services":{
      "title":"Services",
      "desc":"Unleash the full potential of your business with services in design, business, development and technology.",
      "url":"/services",
      "items":{
        "1":{
          "title":"Business",
          "desc":"Establish a solid foundation for your business and strategize your brand.",
          "url":"/services/business"
        },
        "2":{
          "title":"Design",
          "desc":"Distinguish your business through branding , 3D, animation and more.",
          "url":"/services/design"
        },
        "3":{
          "title":"Development",
          "desc":"Web, mobile, and desktop solutions backed with security and support.",
          "url":"/services/development"
        },
        "4":{
          "title":"Technology",
          "desc":"Next-gen solutions to unlock new possibilities for your business.",
          "url":"/services/technology"
        }
      }
    },

    "industries":{
      "title":"Industries",
      "desc":"Creating industry based solutions to support your business infrastructure and take you to the digital era.",
      "url":"/industries",
      "items":{
        "1":{
          "title":"Ecommerce",
          "desc":"Simplifying the buying and selling process with user friendly stores.",
          "url":"/industries/ecommerce"
        },
        "2":{
          "title":"Healthcare",
          "desc":"Revolutionizing the healthcare industry by integrating technology.",
          "url":"/industries/healthcare"
        },
        "3":{
          "title":"Education",
          "desc":"Whether a system, website or app, we tailor it around learning needs.",
          "url":"/industries/education"
        },
        "4":{
          "title":"News",
          "desc":"We help you spread the word and  establish trust with your audience.",
          "url":"/industries/news"
        }
      }
    },
    "ctaText":"With a culture  of innovation in mind, we march towards boosting humanity and creating experiences that people love.",
    "cta":"Let's have <br> Coffee together."
  },
  "ar": {
    "pageTitle":"القدرات",
    "pageDesc":"في بيانات نبتكر من أجل تلبية الاحتياجات البشرية في مختلف المجالات خبراتنا من خلال الخدمات والصناعات والحلول والمنصات.",
    "mantra":"ابتكارات مصممة لتلبية |مختلف الاحتياجات. ",
    "solutions":{
      "title":"الحلول",
      "desc":"نبتكر حلول قائمة على الصناعة لدعم البنية التحتية لشركتك من خلال التكنولوجيا.",
      "url":"/solutions",
      "items":{
        "1":{
          "title":"العلامة التجارية",
          "desc":"نهتم بإنشاء علامة تجارية على أساس استراتيجي لتدعم عملك التجاري.",
          "url":"/solutions/brand"
        },
        "2":{
          "title":"تطبيقات المواقع",
          "desc":"أسس مواقع  بناء على احتياجات عملك التجاري ومتطلبات عملائك.",
          "url":"/solutions/web-apps"
        },
        "3":{
          "title":"تطبيقات الجوال",
          "desc":"كن مع عملائك في أي مكان من خلال تطبيقات الأندرويد أو iOs.",
          "url":"/solutions/mobile-apps"
        },
        "4":{
          "title":"المتاجر",
          "desc":"أنشئ تواجدك على الإنترنت، واحصل على معدل مبيعات أعلى.",
          "url":"/solutions/store"
        }
      }
    },
    "services":{
      "title":"الخدمات",
      "desc":"أطلق العنان للإمكانات الكاملة لشركتك من خلال خدمات في التصميم والأعمال والتطوير والتكنولوجيا.",
      "url":"/services",
      "items":{
        "1":{
          "title":"الأعمال التجارية",
          "desc":"نساعدك على تأسيس عملك التجاري بشكل استراتيجي فعال.",
          "url":"/services/business"
        },
        "2":{
          "title":"البرمجة",
          "desc":"نقدم لك حلول الويب والجوال وسطح المكتب مدعومة بالأمان.",
          "url":"/services/development"
        },
        "3":{
          "title":"التصميم",
          "desc":"اجعل عملك مميز من خلال الثري دي والأنيميشن والعلامة التجارية.",
          "url":"/services/design"
        },
        "4":{
          "title":"التكنولوجيا",
          "desc":"نعتمد على تقنيات التكنولوجيا المختلفة من أجل نجاح أعمالك.",
          "url":"/services/technology"
        }
      }
    },

    "industries":{
      "title":"الصناعات",
      "desc":"نؤسس حلول قائمة على الصناعة لدعم البنية التحتية لشركتك والنهوض به في العصر الرقمي.",
      "url":"/industries",
      "items":{
        "1":{
          "title":"التجارة الإلكترونية",
          "desc":"نصمم المتاجر الإلكترونية لنساعدك على التوسع في أعمالك.",
          "url":"/industries/ecommerce"
        },
        "2":{
          "title":"الرعاية الصحية",
          "desc":"نعمل على إيجاد حلول تقنية من أجل دعم المرضى والأطباء.",
          "url":"/industries/healthcare"
        },
        "3":{
          "title":"التعليم",
          "desc":"نعمل على توفير حلول لتحسين جودة الوسائل التعليمية.",
          "url":"/industries/education"
        },
        "4":{
          "title":"الأغذية",
          "desc":"ندعمك بكافة التكنولوجيا لتقدم الأغذية والمشروبات اللذيذة.",
          "url":"/industries/food"
        }
      }
    },
    "ctaText":"نعتمد على ثقافة الابتكار ونضعها من أولى اهتماماتنا، من أجل تعزيز حاجة البشرية بأكملها وخلق تجارب يحبها الجميع.",
    "cta":"دعنا نتناول القهوة <br> سويًا."
  }
}
</i18n>
